import Service from "../service";
import AuthService from "../AuthService";

const Common = {
    getOrganization() {
        return Service.get('/get-organization')
    },
    getOrderAll(page,user_id) {
        return AuthService.get(`/print-report?page=`+page+'&user_id='+user_id)
    },
    getOrder(id) {
        return AuthService.get(`/get-order/${id}`)
    },
    updateStatusOrder(data) {
        // console.log(data)
        return AuthService.post('/update-status-order', data)
    },
    saveOrder(data) {
        // console.log(data)
        return AuthService.post('/save-order', data)
    },
    saveViewOrder(data) {
        // console.log(data)
        return AuthService.post('/save-view-order', data)
    }
}

export default Common
